import { SeriesDayStatus } from './types';

export const SERIES_DAY_STATUSES: SeriesDayStatus[] = [
  'scheduled',
  'draft',
  'overdue',
  'completed',
  'added',
];

export const seriesDayCalendarStyle: Record<SeriesDayStatus, string> = {
  completed: '[&>button]:bg-primary-50 [&>button]:text-primary-700',
  overdue: '[&>button]:bg-warning-50 [&>button]:text-warning-700',
  draft: '[&>button]:bg-neutral-300 [&>button]:text-white',
  scheduled:
    '[&>button]:border [&>button]:border-neutral-300 [&>button]:bg-white [&>button]:text-neutral-800',
  added:
    '[&>button]:border [&>button]:border-dashed [&>button]:border-primary-500 [&>button]:text-primary-700',
};

export const seriesDayLegendStyle: Record<SeriesDayStatus | 'current', string> = {
  completed: 'border-primary-300 bg-primary-50',
  overdue: 'border-warning-500 bg-warning-50',
  draft: 'border-neutral-300 bg-neutral-300',
  scheduled: 'border-neutral-300 bg-white',
  added: 'border-dashed border-primary-500 bg-white',
  current: 'border-primary-400 bg-primary-400',
};
